import React, { useRef, useState } from 'react';
import { Button, Popover, TextField } from '@mui/material';

import { TooltipEditorModes } from 'src/components/ReviewViewer/Tooltips/types';

import styles from './AddTooltip.module.scss';

type Props = {
    addTooltip: (text: string) => void;
    mode: TooltipEditorModes;
};

const AddTooltip: React.FC<Props> = ({ addTooltip, mode }) => {
    const anchorRef = useRef<HTMLButtonElement>(null);

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [text, setText] = useState<string>('');

    return (
        <>
            <Button
                variant='contained'
                ref={anchorRef}
                disabled={
                    mode === TooltipEditorModes.AddTooltipCoords ||
                    mode === TooltipEditorModes.AddTooltipSizes
                }
                onClick={() => setIsOpen(true)}
            >
                Добавить подсказку
            </Button>
            <Popover
                open={isOpen}
                anchorEl={anchorRef.current}
                onClose={() => setIsOpen(false)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                classes={{ root: styles.MUI, paper: styles.Popover }}
            >
                <TextField
                    value={text}
                    onChange={e => setText(e.target.value)}
                    className={styles.Popover__input}
                    label='Текст'
                    variant='standard'
                />
                <Button
                    variant='contained'
                    onClick={() => {
                        setIsOpen(false);
                        addTooltip(text);
                    }}
                >
                    Добавить
                </Button>
            </Popover>
        </>
    );
};

export { AddTooltip };
